<div class="holder">
  <div class="text-holder">
    <div>{{ text() }}</div>
    <div class="description">{{ description() }}</div>
  </div>

  @if (textValue()) {
    <div class="text">{{ value() }}{{ suffix() }}</div>
  } @else {
    <div
      [class]="{ 'sum' : sum() }">{{ value() | number:format():'sv' }}{{ suffix() }}
    </div>
  }
</div>
